




import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import Vue from 'vue';
import { HostedCheckoutRequest } from '@/Payment/HostedCheckoutRequest';
import PaymentSubmit from '@/Payment/PaymentMethods/PaymentSubmit.vue';

const component = mixins(LocationBasedMixin).extend({
    props: {
        hostedCheckout: {
            required: true,
            type: Object as () => HostedCheckoutRequest
        }
    },
    mounted() {
        const i18nPrefix = 'payment.citationPayment';
        const translatedTitle = this.$i18n.t(`${i18nPrefix}.redirectingTitle`);
        const translatedMessage = this.$i18n.t(`${i18nPrefix}.redirectingMessage`);
        this.$bvToast.toast(translatedMessage.toString(), {
            title: translatedTitle.toString(),
            autoHideDelay: 5000
        });

        const submitter = new PaymentSubmit({
            propsData: {
                request: this.hostedCheckout
            }
        });
        submitter.$props.request = this.hostedCheckout;
        submitter.$mount(this.$refs.slot as Element);
    }
});

export default component;
